import type { SITE_THIRD_PARTY_SENSORS_COUNT_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-third-party-sensors-count-card/site-third-party-sensors-count-card.fr.ts";

export const SITE_THIRD_PARTY_SENSORS_COUNT_CARD_ENGLISH_LOCALE = {
  title: "Sensors",
  subtitle: "On site",
  seeMore: "See more",
} satisfies typeof SITE_THIRD_PARTY_SENSORS_COUNT_CARD_FRENCH_LOCALE;
